const DATA_CENTER_FLAGS: Record<string, string> = {
  us: '🇺🇸',
  eu: '🇪🇺',
};

/**
 * Formats an account's data center for display as a compact region badge, e.g.
 * "🇺🇸 US". Returns an empty string for an empty/unknown-to-us value so callers
 * can skip rendering; an unknown non-empty code falls back to the upper-cased
 * code without a flag.
 */
export function formatDataCenterShort(dataCenter: string | null | undefined): string {
  if (dataCenter == null || dataCenter === '') {
    return '';
  }
  const flag = DATA_CENTER_FLAGS[dataCenter] ?? '';
  return `${flag} ${dataCenter.toUpperCase()}`.trim();
}
